// extracted by mini-css-extract-plugin
var _1 = "WalletFormStyle-module__disabled-select___p2f9W";
var _2 = "WalletFormStyle-module__disabled-select___p2f9W";
var _3 = "WalletFormStyle-module__headline___vdAuh";
var _4 = "WalletFormStyle-module__info___V6eHg";
var _5 = "WalletFormStyle-module__select___rTXdx";
var _6 = "WalletFormStyle-module__wallet-form___WDZmg";
var _7 = "WalletFormStyle-module__wallet-form___WDZmg";
export { _1 as "disabled-select", _2 as "disabledSelect", _3 as "headline", _4 as "info", _5 as "select", _6 as "wallet-form", _7 as "walletForm" }
